import { getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

export const dashboardStudent = data =>
  getInstance().get(API.DASHBOARD_STUDENT, {
    params: data,
  })
